// extracted by mini-css-extract-plugin
export default {"providerBadges":"storeTableUi_providerBadges__uqu+0","rowActions":"storeTableUi_rowActions__Ivq3I"};